module.exports = __webpack_public_path__ + "static/venice20895-fdd7f3957d7bd656efd4d0360d547ccb.png";